export default class CookieStorage {
    data = {};
    keys = [];

    createCookie(name, value, daysUntilExpired) {
        let expires = '';

        if (daysUntilExpired) {
            const date = new Date();
            date.setTime(date.getTime() + (daysUntilExpired*24*60*60*1000));
            expires = `;expires=${date.toUTCString()}`;
        }

        document.cookie = `${name}=${value}${expires};path=/`;
    }

    readCookie(name) {
        const nameEQ = `${name}=`;
        const cookieArray = decodeURIComponent(document.cookie).split(';');
        let c;

        for (let i = 0; i < cookieArray.length; i += 1) {
            c = cookieArray[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1,c.length);
            }

            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length,c.length);
            }
        }
        return null;
    }

    setData() {
        const data = JSON.stringify(this.data);
        this.createCookie('localStorage', data);
    }

    clearData() {
        this.createCookie('localStorage', '');
    }

    getData() {
        const data = JSON.parse(this.readCookie('localStorage'));

        if (data && typeof data === 'object') {
            this.data = data;
            this.keys = Object.keys(this.data);
        }
        else {
            this.data = {};
            this.keys = [];
        }
    }

    setItem(key, value) {
        this.getData();
        this.keys = [ ...this.keys, key ];
        this.data[key] = String(value);
        this.setData();
    }

    getItem(key) {
        this.getData();
        const item = this.data[key];
        return item || null;
    }

    removeItem(key) {
        delete this.data[key];
        this.keys = this.keys.filter((item) => item !== key);
        this.setData();
    }

    clear() {
        this.data = {};
        this.keys = [];
        this.clearData();
    }

    get length() {
        this.getData();
        return this.keys.length;
    }
}
